const map = {
	FHDE: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "ZipCodeInput" },
		//{name: "StateSelect"},
		{ name: "CityInput" },
		{ name: "AddressInput" },
		{ name: "AddressNumberInput" },
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
	FHGR: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "ZipCodeInput" },
		//{name: "StateSelect"},
		{ name: "CityInput" },
		{ name: "AddressInput" },
		{ name: "AddressNumberInput" },
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
	FHAT: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "ZipCodeInput" },
		//{name: "StateSelect"},
		{ name: "CityInput" },
		{ name: "AddressInput" },
		{ name: "AddressNumberInput" },
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
	FHNL: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "ZipCodeInput" },
		//{name: "StateSelect"},
		{ name: "CityInput" },
		{ name: "AddressInput" },
		{ name: "AddressNumberInput" },
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
	FHUK: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "AddressInput", xs: 12 },
		{ name: "CityInput" },
		//{name: "StateSelect"},
		{ name: "ZipCodeInput" },
		//{name: "AddressNumberInput"},
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
	FHCA: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "AddressInput", xs: 12 },
		{ name: "CityInput" },
		//{name: "StateSelect"},
		{ name: "ZipCodeInput" },
		//{name: "AddressNumberInput"},
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
	FHUS: [
		{ name: "AutoCompleteField" },
		{ name: "AddressTitle" },
		{ name: "FirstNameInput" },
		{ name: "LastNameInput" },
		{ name: "AddressInput", xs: 12 },
		{ name: "CityInput" },
		{ name: "StateSelect" },
		{ name: "ZipCodeInput" },
		//{name: "AddressNumberInput"},
		{ name: "AddressLine2Input" },
		{ name: "AddressLine3Input" },
		{ name: "PersonalInfoTitle" },
		{ name: "PhoneInput" },
	],
};
export function getOrderBySiteId(siteId) {
	if (siteId) {
		return map[siteId];
	}
	return map.FHUK;
}
